import { useAuth0 } from '@auth0/auth0-react';
import { appConfig } from '../library/utils/appConfig';

const isDev = process.env.REACT_APP_ENV === 'development';

/**
 * Redirects the user into the Auth0 login flow.
 * Mirrors the shell-app handoff previously inlined in LoginGate.
 */
export const useLoginRedirect = (): { handleLoginClick: () => void } => {
  const { loginWithRedirect } = useAuth0();

  const handleLoginClick = () => {
    if (isDev) {
      /**
       * LOCAL DEV: call loginWithRedirect() directly from this app.
       * This passes redirect_uri=http://localhost:3000 to Auth0,
       * so Auth0 sends the user back here after login — not to stage.
       *
       * Requires http://localhost:3000 in Auth0 Allowed Callback URLs.
       */
      void loginWithRedirect({
        redirectUri: window.location.origin,
        appState: { returnTo: window.location.href },
      });
    } else {
      /**
       * STAGE / PRODUCTION: go through the shell app.
       * Shell app and AI app share the same domain, so localStorage
       * authentication_origin_path is readable by the shell app.
       */
      const currentUrl = encodeURIComponent(window.location.href);
      window.location.href = `${appConfig.shellAppUrl}/en-us/auth?path=${currentUrl}`;
    }
  };

  return { handleLoginClick };
};
